/* Delivery page behaviour (sections/ll-delivery.liquid). Everything is scoped to the .ll-dv root. */
(() => {
  const root = document.querySelector('.ll-dv');
  if (!root) return;
  const $ = (s) => root.querySelector(s);

  // routes from the store to towns across NZ, drawn one after another, then a parcel runs each line
  const P = { store: [339.8, 142.9], Whangarei: [322.2, 80.3], Hamilton: [361.5, 192.5], Tauranga: [399.5, 188.2], Gisborne: [475.8, 244.3], Napier: [427.3, 287], NewPlymouth: [309.3, 260.1], Wellington: [336.3, 381], Nelson: [275.8, 379.4], Christchurch: [250, 501.5], Queenstown: [98.7, 586.9], Dunedin: [170.4, 629.7], Invercargill: [91.2, 662.2] };
  const home = P.store, NS = 'http://www.w3.org/2000/svg', g = $('#dvRoutes');
  const mk = (t, a) => { const e = document.createElementNS(NS, t); for (const k in a) e.setAttribute(k, a[k]); return e; };
  Object.keys(P).filter((k) => k !== 'store').forEach((k, i) => {
    const [x, y] = P[k], mx = (home[0] + x) / 2, my = (home[1] + y) / 2, dx = x - home[0], dy = y - home[1], c = [mx - dy * .22, my + dx * .22];
    const d = `M${home[0]} ${home[1]}Q${c[0].toFixed(1)} ${c[1].toFixed(1)} ${x} ${y}`;
    const p = mk('path', { d, class: 'rt' }); g.append(p); p.style.setProperty('--len', p.getTotalLength());
    const dot = mk('circle', { cx: x, cy: y, r: 6, class: 'tw' }); g.append(dot);
    const begin = (1.4 + i * .35).toFixed(2) + 's';
    const van = mk('circle', { r: 4.5, class: 'van', opacity: 0 });
    van.append(mk('animateMotion', { dur: (1.6 + p.getTotalLength() / 220).toFixed(1) + 's', repeatCount: 'indefinite', path: d, begin }), mk('set', { attributeName: 'opacity', to: 1, begin }));
    g.append(van);
    setTimeout(() => { p.classList.add('go'); setTimeout(() => dot.classList.add('go'), 700); }, 500 + i * 160);
  });
  g.append(mk('circle', { cx: home[0], cy: home[1], r: 12, class: 'pin-ring' }), mk('circle', { cx: home[0], cy: home[1], r: 10, class: 'pin' }));

  // delivery policy: index + reader, one part at a time
  const tabs = [...root.querySelectorAll('.pl-idx [role=tab]')], pans = [...root.querySelectorAll('.pl-pan')];
  let cur = 0;
  const showPart = (i, focus) => {
    cur = (i + tabs.length) % tabs.length;
    tabs.forEach((t, j) => { t.setAttribute('aria-selected', j === cur); t.tabIndex = j === cur ? 0 : -1; });
    pans.forEach((p, j) => { p.hidden = j !== cur; });
    if (focus) tabs[cur].focus();
  };
  tabs.forEach((t, i) => {
    t.addEventListener('click', () => showPart(i));
    t.addEventListener('keydown', (e) => { const d = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key]; if (d) { e.preventDefault(); showPart(cur + d, true); } });
  });
  root.querySelectorAll('.pl-nav [data-step]').forEach((b) => b.addEventListener('click', () => showPart(cur + +b.dataset.step)));

  // report a problem pop-up
  const dlg = $('#dvDlg'), form = $('#dv-form'), send = $('#dvSend');
  window.LLCaptcha.mount(form); // visible tick box above the send button (assets/ll-enquiry.js)
  const close = () => dlg.close();
  $('#dvRepOpen').addEventListener('click', () => dlg.showModal());
  dlg.addEventListener('click', (e) => { if (e.target === dlg || e.target.closest('[data-close]')) close(); });
  dlg.addEventListener('close', () => { if (dlg.classList.contains('ok')) { dlg.classList.remove('ok'); form.reset(); } });
  if ($('#dvPosted')) { dlg.classList.add('ok'); dlg.showModal(); } // came back from the Shopify fallback
  else if (location.hash === '#report') dlg.showModal(); // linked from the Help page

  // optional photo goes to Shopify Files through the trade upload function
  const cfg = JSON.parse(document.getElementById('dvCfg').textContent);
  const file = $('#dvPhoto'), link = $('#dvPhotoLink'), drop = file.closest('.drop');
  const dropTitle = drop.querySelector('b'), dropSub = drop.querySelector('span');
  const titleDefault = dropTitle.textContent, subDefault = dropSub.textContent;
  file.addEventListener('change', async () => {
    link.value = ''; drop.classList.remove('got');
    dropTitle.textContent = titleDefault; dropSub.textContent = subDefault;
    const f = file.files[0]; if (!f) return;
    if (f.size > 4 * 1024 * 1024) { dropSub.textContent = 'That photo is over 4 MB. Please choose a smaller one.'; file.value = ''; return; }
    send.disabled = true; dropSub.textContent = 'Uploading...';
    try {
      const r = await fetch(cfg.uploadUrl, { method: 'POST', headers: { 'content-type': f.type, 'x-filename': encodeURIComponent(f.name), 'x-captcha': await window.LLCaptcha(file.form) }, body: f });
      const j = await r.json(); if (!r.ok) throw new Error(j.error);
      link.value = j.url; drop.classList.add('got'); dropTitle.textContent = f.name; dropSub.textContent = 'Photo added.';
    } catch (e) {
      dropSub.textContent = "Upload didn't work. You can still send the form without it."; file.value = '';
    }
    send.disabled = false;
  });

  // our own send (team email + customer thank-you); Shopify's contact email is the fallback
  let viaShopify = false;
  // capture phase on document: runs before Shopify's hCaptcha listener on contact forms, which would post the form first
  document.addEventListener('submit', async (ev) => {
    if (ev.target !== form || viaShopify || !cfg.enquiryUrl) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    const fd = new FormData(form), get = (k) => (fd.get('contact[' + k + ']') || '').toString();
    const data = { type: 'problem', website: (fd.get('website') || '').toString() };
    ['problem', 'name', 'order', 'email', 'body', 'photo_link'].forEach((k) => { data[k] = get(k); });
    send.disabled = true;
    try {
      const r = await fetch(cfg.enquiryUrl, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ ...data, captcha: await window.LLCaptcha(form) }) });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || !j.ok) throw new Error(j.error || 'send');
      dlg.classList.add('ok');
    } catch (e) {
      viaShopify = true;
      form.requestSubmit(); // fallback: Shopify contact email (with its captcha), nothing lost
    }
    send.disabled = false;
  }, true);
})();
